import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import { AlertTriangleIcon } from 'lucide-react';
import { colors } from '../utils/colors';
const Layout = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-33">
      <header className="bg-white border-b border-gray-200" data-id="element-34">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
          <div className="flex justify-between items-center h-16" data-id="element-36">
            <div className="flex items-center" data-id="element-37">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1hBys33aV6NS7ofxzmeFBA/MfE_logo.png" alt="Ministry for the Environment" className="h-10" data-id="element-38" />
              <div className="ml-4 text-lg font-semibold" style={{
              color: colors.primary.dark
            }} data-id="element-39">
                Submission Analysis Platform
              </div>
            </div>
            <div className="flex items-center" data-id="element-40">
              <div className="mr-4 flex items-center text-sm text-gray-600" data-id="element-41">
                <AlertTriangleIcon className="h-4 w-4 mr-1" style={{
                color: colors.primary.light
              }} data-id="element-42" />
                <span data-id="element-43">Water Reform Consultation</span>
              </div>
              <div className="relative" data-id="element-44">
                <button className="flex items-center text-sm font-medium hover:opacity-80" style={{
                color: colors.primary.medium
              }} data-id="element-45">
                  <span className="mr-1" data-id="element-46">Analyst Portal</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Navigation data-id="element-47" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-48">
        <Outlet data-id="element-49" />
      </main>
      <footer className="bg-white border-t border-gray-200 py-4" data-id="element-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
          <div className="text-center text-sm text-gray-500" data-id="element-52">
            © {new Date().getFullYear()} Ministry for the Environment |
            Submission Analysis Platform
          </div>
        </div>
      </footer>
    </div>;
};
export default Layout;